import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Skeleton } from '@/components/ui/FeedBack/Skeleton';
import { hotLineFormActionsStyle } from '@/feature/hotline/component/HotLineFormActions/style';
/**
 * 匿名コンサルホットライン Form ボタン
 */
export const HotLineFormActionsSkeleton = (props) => {
    const { className = '' } = props;
    const style = hotLineFormActionsStyle();
    return (_jsxs("div", Object.assign({ className: style.base({ class: className }) }, { children: [_jsx(Skeleton, { className: style.button({ class: 'w-[300px] h-[48px]' }) }), _jsx(Skeleton, { className: style.button({ class: 'w-[300px] h-[48px]' }) })] })));
};
